import { createApp } from 'vue'
import mitt from 'mitt'

const emitter = mitt()

import ProductGallery from './components/product-gallery.vue'
import ProductsFilter from './components/products-filter.vue'
import Mascus from './components/mascus/mascus.vue'
import MascusSingleRelatedProducts from './components/mascus/single-related-products.vue'
import ContactsFilter from './components/contacts-filter.vue'


const app = createApp({
	components: {
		ProductGallery,
		ProductsFilter,
		Mascus,
		ContactsFilter
	}
})
app.config.globalProperties.emitter = emitter


if (document.getElementById('vue-product-gallery')) {
	app.mount('#vue-product-gallery')
}

if (document.getElementById('vue-products-filter')) {
	app.mount('#vue-products-filter')
}


if (document.getElementById('vue-mascus')) {
	app.mount('#vue-mascus')
}

// Im sorry for all of this... But needed to split vue app with gravity forms...
const app2 = createApp({
	components: {
		MascusSingleRelatedProducts
	}
})
app2.config.globalProperties.emitter = emitter
if (document.getElementById('vue-mascus-single-related-products')) {
	app2.mount('#vue-mascus-single-related-products')
}

if (document.getElementById('vue-contacts-filter')) {
	app.mount('#vue-contacts-filter')
}
